import React from 'react';

const TOPIC_TITLES: Record<string, string> = {
  id_card: 'Your ID Card',
  what_is_listener: 'What is a Peer Listener?',
  what_is_story: 'What is a Story?',
  what_is_resource: 'What is a Resource?',
  how_to_call: 'How to Make a Call',
};

interface FiFaqMessageProps {
  topic: string;
  message: string;
  followup?: string;
}

export const FiFaqMessage: React.FC<FiFaqMessageProps> = ({ topic, message, followup }) => {
  const title = TOPIC_TITLES[topic] || 'FAQ';

  return (
    <div className="space-y-2">
      <div className="rounded-xl border border-blue-100 bg-blue-50/60 p-4">
        <p className="font-albert-sans mb-1 text-sm font-semibold text-gray-900">{title}</p>
        <p className="font-open-sans text-sm leading-relaxed text-gray-800">{message}</p>
      </div>
      {followup ? (
        <div className="rounded-2xl bg-orange-50/90 px-4 py-2">
          <p className="font-open-sans text-sm leading-5 text-gray-900">{followup}</p>
        </div>
      ) : null}
    </div>
  );
};
